function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
/**
 * This file and the other files in the ./thirdparty folder are representative of the
 * react-google-recaptcha library which our Captcha was initially built upon. These files
 * are neceesary because a react-google-recaptcha dependency utilizes ES6 function calls not yet
 * supported in IE10 or IE11.
 *
 * This folder WILL BE REMOVED once we move to the new dependency system, and we will again
 * include the npm packages directly so as to abstract any recaptcha/react updates that may be
 * necessary
 *
 * Ticket to remove once on new dependency system: EB-56120
 */
//eslint-disable-next-line

import PropTypes from 'prop-types';

var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _classCallCheck(this, ReCAPTCHA);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCAPTCHA).call(this));

    _defineProperty(_assertThisInitialized(_this), "handleExpired", function () {
      if (_this.props.onExpired) {
        _this.props.onExpired();
      } else if (_this.props.onChange) {
        _this.props.onChange(null);
      }
    });

    _this.state = {};
    return _this;
  }

  _createClass(ReCAPTCHA, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.explicitRender();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.explicitRender();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if (this.props.grecaptcha && this.state.widgetId !== undefined) {
        return this.props.grecaptcha.getResponse(this.state.widgetId);
      }

      return null;
    }
  }, {
    key: "execute",
    value: function execute() {
      var grecaptcha = this.props.grecaptcha;
      var widgetId = this.state.widgetId;

      if (grecaptcha && widgetId !== undefined) {
        return grecaptcha.execute(widgetId);
      }

      return null;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.props.grecaptcha && this.state.widgetId !== undefined) {
        this.props.grecaptcha.reset(this.state.widgetId);
      }
    }
  }, {
    key: "explicitRender",
    value: function explicitRender(cb) {
      if (this.props.grecaptcha && this.state.widgetId === undefined) {
        //eslint-disable-next-line
        var id = this.props.grecaptcha.render(this.refs.captcha, {
          sitekey: this.props.sitekey,
          callback: this.props.onChange,
          theme: this.props.theme,
          type: this.props.type,
          tabindex: this.props.tabindex,
          'expired-callback': this.handleExpired,
          size: this.props.size,
          stoken: this.props.stoken,
          badge: this.props.badge
        });
        this.setState({
          widgetId: id
        }, cb);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          sitekey = _this$props.sitekey,
          onChange = _this$props.onChange,
          theme = _this$props.theme,
          type = _this$props.type,
          tabindex = _this$props.tabindex,
          onExpired = _this$props.onExpired,
          size = _this$props.size,
          stoken = _this$props.stoken,
          grecaptcha = _this$props.grecaptcha,
          badge = _this$props.badge,
          childProps = _objectWithoutProperties(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
      /* eslint-enable no-unused-vars */


      return (//eslint-disable-next-line
        React.createElement("div", _extends({}, childProps, {
          ref: "captcha"
        }))
      );
    }
  }]);

  return ReCAPTCHA;
}(React.Component);

export { ReCAPTCHA as default };
ReCAPTCHA.displayName = 'ReCAPTCHA';
ReCAPTCHA.propTypes = {
  sitekey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  //eslint-disable-next-line
  grecaptcha: PropTypes.object,
  theme: PropTypes.oneOf(['dark', 'light']),
  type: PropTypes.oneOf(['image', 'audio']),
  tabindex: PropTypes.number,
  onExpired: PropTypes.func,
  size: PropTypes.oneOf(['compact', 'normal', 'invisible']),
  stoken: PropTypes.string,
  badge: PropTypes.oneOf(['bottomright', 'bottomleft ', 'inline'])
};
ReCAPTCHA.defaultProps = {
  theme: 'light',
  type: 'image',
  tabindex: 0,
  size: 'normal',
  badge: 'bottomright'
};